import React from 'react'
import ForgottenPasswordForm from '../page-contents/ForgottenPasswordForm/ForgottenPasswordForm'

const ForgottenPassword: React.FC = () => {
  return (
    <>
      <ForgottenPasswordForm />
    </>
  )
}

export default ForgottenPassword;
